import { createCachedApiReducer } from '../../../utils/api-state';
import { getOptInActions, updateOptInSuccess } from './opt-in.actions';
import { on } from '@ngrx/store';
import { getUpdatedOptInState } from '../util/opt-in.util';

export const getOptInReducer = createCachedApiReducer(
  getOptInActions,
  undefined,
  on(updateOptInSuccess, (state, { response }) => {
    return {
      ...state,
      response: getUpdatedOptInState(state.response, response),
    };
  })
);
